module.exports = __webpack_public_path__ + "img/ES02.eb3d04d7.svg";